var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStep2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    fill: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9207 20.5835V19.1226L15.5888 14.6896C15.9806 14.3202 16.2717 13.9956 16.462 13.7157C16.6523 13.4358 16.7754 13.1784 16.8314 12.9433C16.8985 12.697 16.9321 12.4675 16.9321 12.2548C16.9321 11.7175 16.7474 11.3033 16.378 11.0122C16.0086 10.71 15.4657 10.5589 14.7492 10.5589C14.1783 10.5589 13.6578 10.6596 13.1876 10.8611C12.7286 11.0626 12.3312 11.3705 11.9954 11.7847L10.4673 10.6092C10.9263 9.99355 11.542 9.51779 12.3144 9.18195C13.098 8.83493 13.9712 8.66141 14.9339 8.66141C15.7847 8.66141 16.5235 8.80134 17.1504 9.0812C17.7885 9.34987 18.2755 9.73608 18.6113 10.2398C18.9583 10.7436 19.1318 11.3425 19.1318 12.0365C19.1318 12.4171 19.0815 12.7978 18.9807 13.1784C18.88 13.5478 18.6897 13.9396 18.4098 14.3538C18.1299 14.768 17.7213 15.2326 17.184 15.7475L13.1708 19.5592L12.7174 18.7364H19.5852V20.5835H10.9207Z",
    fill: "#1B1A1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep2);
export default __webpack_public_path__ + "static/media/Step2.7bbecdc471dff0ea68edcda3bb50d24e.svg";
export { ForwardRef as ReactComponent };